// If a individual loop count was set, add additional values For animations and videos.
export const calculatePlayTime = (contentObj, duration, loop = false) => {
	contentObj.duration = duration;

	if (loop) {
		loop = parseInt(loop);
		if (isNaN(loop)) loop = 1;
		contentObj.loopCount = loop;
	}
	if (loop) contentObj.loopDuration = loop * duration;
};

// Calculates the duration in seconds and returns the value in milliseconds.
export const getAnimationDurationInMilliseconds = (frames, frameRate) => {
	const seconds = frames / frameRate;
	const milliseconds = parseInt(seconds * 1000);
	return milliseconds;
};

export const getIndex = (el) => parseInt(el.getAttribute('data-index'));
